import OutlineButton from '@/components/ui/custom/buttons/OutlineButton';
import { LocaleDayPicker } from '@/components/ui/custom/dataInput/LocaleDayPicker';
import ToggleButtonGroup from '@/components/ui/custom/dataInput/ToggleGroup';
import Popup from '@/components/ui/custom/Popup';
import { enUS, ptBR } from 'date-fns/locale';
import { useInput } from 'react-day-picker';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AlertFiltersOptions } from './NotificationsPageContent';
import { timezonedToBrowserDate } from '@/utils/datetimes';
import useAuth from '@/data/hook/useAuth';

export default function NotificationStatusFilter() {
  const {
    t,
    i18n: { language },
  } = useTranslation('translation', { keyPrefix: 'alerts.filters' });
  const { user } = useAuth();
  const { setValue, control } = useFormContext<AlertFiltersOptions>();
  const statusOptions = [
    { text: t('status.all'), value: 'all' },
    { text: t('status.today'), value: 'today' },
    { text: t('status.yesterday'), value: 'yesterday' },
  ];
  const localeLanguage = {
    locale: language === 'pt_BR' ? ptBR : enUS,
  };
  const { inputProps, dayPickerProps, setSelected } = useInput({
    fromYear: 1960,
    toYear: new Date().getFullYear(),
    locale: localeLanguage.locale,
    format: 'dd/MM/yyyy',
  });

  const onChangeStatus = () => {
    setSelected(undefined);
  };

  const onChangeDate = (e?: Date) => {
    if (e) {
      setValue('status', 'chooseDate');
      setValue('date', timezonedToBrowserDate(e, user?.timezone));
      return;
    }

    setSelected(e);
    setValue('status', 'all');
  };
  return (
    <div className="flex flex-wrap gap-2">
      <Controller
        name="status"
        control={control}
        render={({ field }) => (
          <ToggleButtonGroup
            exclusive
            size="medium"
            buttons={statusOptions}
            value={field.value}
            onChange={e => {
              field.onChange(e);
              onChangeStatus();
            }}
          />
        )}
      />
      <Popup
        hover
        className={{ popup: 'z-10' }}
        reference={
          <OutlineButton
            className={{ base: 'px-3 py-1.5' }}
            text={inputProps.value?.toString() || t('status.chooseDate')}
            active={!!inputProps.value}
          />
        }
      >
        <LocaleDayPicker
          {...dayPickerProps}
          mode="single"
          onSelect={onChangeDate}
        />
      </Popup>
    </div>
  );
}
